<!-- <app-industry-report-competitor-component></app-industry-report-competitor-component> -->
<app-industry-report-suggestion></app-industry-report-suggestion>
